module.exports = __webpack_public_path__ + "project-chip.296423582c27ded618f662efc94a1a0a.hashedasset.svg";